import { MutableRefObject, useCallback, useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { localconsole } from "../App";
import CompsInput from "./CompsInput";
import { Comp, CompDictionary, CompFieldsDictionary, getCompReference } from "../state/objects/comp";
import { useAppDispatch, useAppSelector } from "../state/hooks";
import { copyTable, delTable, removeCompTag, selectComp, selectCurrentProject, swapComps, tagComp, upsertTable } from "../state/slices/systemSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faCopy, faTag, faTrash } from "@fortawesome/free-solid-svg-icons";
import ColorPicker from "./ColorPicker";
import Cols from "./cols";
import { getEmptyImage } from "react-dnd-html5-backend";




const DraggableComp = (props: {compKey: string, isActive: boolean, compId: string, setActive: () => void, setInactive: () => void }) => {

    const dispatch = useAppDispatch()
    const currentProject = useAppSelector(state => selectCurrentProject(state));
    const items = useAppSelector(state => currentProject.components)
    const colors = useAppSelector(state => currentProject.colors)
    const comp = useAppSelector(state => selectComp(props.compId)(state))

    const binComp = (item_id: string) => {
        dispatch(delTable(item_id))
    }

    const copyComp = (item_id: string) => {
        dispatch(copyTable(item_id))
    }


    //cancelling drag and drop
    const originalIndex = props.compKey



    //dnd functions
    const findItem = useCallback(
        (id: string) => {
            //localconsole(`findItem: ${id}`)
        const keyComp = Object.entries(items).filter(([i, c]) => c.id == id)[0]
        const item = keyComp[1]
        return {
            item,
            index: item.id,
        }
        },
        [items],
    )

    //const {item : activeComp} = findItem(props.compId);

    const activeCompTags = props.isActive ? comp?.tags?.map((tag, i) => {
        return (<div className="control" key={`t_${i}`}>
                    <div className="tags has-addons">
                        <a className="tag">{`${tag}`}</a>
                        <a className="tag is-delete" onClick={(e) => {
                            if (comp) {
                                dispatch(removeCompTag({component_id: comp.id, tag: tag}))
                            }
                        }}></a>
                    </div>
                </div>)
    }) : null;

    const moveItem = useCallback(
        (id: string, overId: string, insertBefore: boolean) => {
            localconsole(`move ${id} ${insertBefore ? 'before' : 'after'} ${overId}`)

        dispatch(swapComps({from: id, to: overId, insertBefore: insertBefore}))

        },
        [items],
    )

    /*useEffect(() => {
            preview(getEmptyImage(), { captureDraggingState: true });
        }, []);*/

    const [{ isDragging }, drag] = useDrag(
        () => ({
        type: 'component',
        item: { id: props.compId, compKey: originalIndex },
        canDrag: (monitor) => {
            return !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName ?? "")
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //lastTargetIndex.current = null
            const { id: droppedId, compKey } = item
            const didDrop = monitor.didDrop()
            if (!didDrop) {
                //revert the item to original position
                localconsole(`revert ${droppedId} to ${compKey}`)
                let keys = Object.keys(items)
                const fromIndex = keys.findIndex(k => items[k].id === droppedId);
                const toIndex = keys.findIndex(k => k === compKey);

                //direction
                const direction = fromIndex < toIndex ? false : true;

                moveItem(droppedId, items[compKey].id , direction);

            }
        },
        }),
        [props.compId, originalIndex, moveItem, items],
    )

    const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)

    //localconsole(`Render Draggable component`)
    //localconsole(comp)

    const [, drop] = useDrop(
        () => ({
        accept: 'component',
        hover({ id }: { id: string }, monitor) {
            //localconsole(`Hovering over ${id}`)

            //don't move over itself
            if (id === props.compId) return;

            //const { index: overIndex } = findItem(comp.id);
            //const { index: dragIndex } = findItem(id);
            const overIndex = props.compId;
            const dragIndex = id;

            //don't move if already switched
            if (dragIndex === overIndex) return;

            //don't jump back and forth
            //if (lastTargetIndex.current === overIndex) return;

            //lastTargetIndex.current = overIndex;

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            if (!hoverBoundingRect) return
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset) return
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (hoverClientY > hoverMiddleY) {
                // insert after
                localconsole(`Below`)
                moveItem(dragIndex, overIndex, false)
            } else {
                // insert before
                localconsole(`Above`)
                moveItem(dragIndex, overIndex, true)
            }


        },
        }),
        [findItem, moveItem],
    )

    const addTag = (component_id: string) => {
        //e.currentTarget.classList.remove("pulse");
        let input = window.prompt("Add Tag:");
        if (input){
            dispatch(tagComp({component_id: component_id, tag: input}))
        }
    }


    const addGrey = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!props.isActive) {
            e.currentTarget.classList.add("has-background-grey-lighter")
        }
    }
    const removeGrey = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.currentTarget.classList.remove("has-background-grey-lighter")
    }
    const toggleRow = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        //e.stopPropagation();
        /*if (iAmActive) {
            setCompId(0);
            setCompName("");
            setCompDBName("");
            setCompAlias("");
            setCompDescription("");
        }*/
        removeGrey(e)
        if(props.isActive) {
            props.setInactive()
        } else {
            props.setActive()
        }

    }

    const setRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
        drag(drop(node))
        ref.current = node // store DOM for rect access
    }
    }, [drag, drop])

    return (!comp) ? null : (
        <div className={"card is-shadowless"}
                key={props.compId} data-key={props.compId}
                style={{opacity: isDragging ? 0 : 1}}

        >
            <header className={"card-header" +
                ((props.isActive) ? " has-background-primary has-text-light" : "")
            }
                    onClick={toggleRow}
                    onMouseEnter={addGrey}
                    onMouseLeave={removeGrey}
                    onDragStart={e => props.setInactive()}
                    ref={!props.isActive ? setRef : undefined}
            >
                <p className={"card-header-title" +
                    ((comp.columns.length > 0) ? " has-text-weight-medium" : " has-text-weight-light") +
                    ((props.isActive) ? " has-text-light" : "")
                }
                >
                    {getCompReference(comp)}
                </p>

                {(props.isActive) ? <>
                        <button className={"card-header-icon "} aria-label="delete component"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    binComp(props.compId)
                                }}
                                title={"Delete Component"}
                        >
                        <span className={"icon"}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </span>
                        </button>
                        <button className={"card-header-icon  "} aria-label="copy component" onClick={(e) => {
                            e.stopPropagation();
                            copyComp(comp.id)
                        }}
                                title={"Copy Component"}
                        >
                    <span className={"icon"}>
                        <FontAwesomeIcon icon={faCopy}/>
                    </span>
                        </button>
                        <button className={"card-header-icon"} aria-label="add tag" onClick={(e) => {
                            e.stopPropagation();
                            addTag(comp.id)
                        }}
                                title={"Tag Component"}
                        >
                    <span className={"icon"}>
                        <FontAwesomeIcon icon={faTag}/>
                    </span>
                        </button>
                    </>
                    : null}
                <button className="card-header-icon" aria-label="more options"
                style={{ backgroundColor: '${comp.colors.Background}'}}>
                    <span className="icon">
                    {(props.isActive) ? <FontAwesomeIcon icon={faAngleUp}/> : <FontAwesomeIcon icon={faAngleDown}/>}
                    </span>
                </button>
            </header>
            {
                (props.isActive) ?
                    <div className={"card-content"}>







                        <div className={"block"}>

                        {(comp.tags?.length > 0) ? <div className="field is-horizontal">
                                <div className="field-label">
                                    <label className="label">Tags</label>
                                </div>
                                <div className="field-body">
                                <div className="field is-grouped is-grouped-multiline">
                                    {activeCompTags}
                            </div>
                        </div>
                    </div>:<div></div>}

                            <div className="field is-horizontal">
                                <div className="field-label is-normal">
                                    <label className="label">Name</label>
                </div>
                <div className="field-body">
                            <div className="field has-addons">
                                <p className="control is-expanded">
                                    <CompsInput record={comp} field={CompFieldsDictionary.name}
                                                setRecord={(c) => dispatch(upsertTable(c))}
                                                activateRecord={() => props.setActive()}/>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="field is-horizontal">
                        <div className="field-label is-normal">
                            <label className="label">Table</label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <p className="control">
                                    <CompsInput record={comp} field={CompFieldsDictionary.db_name} setRecord={(c) => dispatch(upsertTable(c))} activateRecord={() => props.setActive()} />
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="field is-horizontal">
                        <div className="field-label is-normal">
                            <label className="label">Alias</label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <p className="control">
                                    <CompsInput record={comp} field={CompFieldsDictionary.alias} setRecord={(c) => dispatch(upsertTable(c))} activateRecord={() => props.setActive()} />
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="field is-horizontal">
                        <div className="field-label is-normal">
                            <label className="label">Description</label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <p className="control">
                                    <CompsInput record={comp} field={CompFieldsDictionary.description} setRecord={(c) => dispatch(upsertTable(c))} activateRecord={() => props.setActive()} />
                                </p>
                            </div>
                        </div>
                    </div>



                                <ColorPicker color={(comp.colors ?? {})["Background"] ?? colors["Background"]} setColor={(kv) => {
                                    let c: Comp = {
                                        ...comp,
                                        colors: {...comp.colors}  //clone so I can modify
                                    };
                                    (c.colors ?? {})[kv.key] = kv.value
                                    dispatch(upsertTable(c))
                                }}
                                    name={"Background"}
                                    label={"Background"}
                                    boldLabel={true}
                                />



                </div>
                <div>
                    <Cols compKey={props.compKey}/>
                </div>
            </div>:<div></div>}

        </div>

    )
}

export default DraggableComp
